import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { ERROR_DIALOG } from '../../../../constants/errorDialogConstants';
import { useHandleQueryError } from '../../../../helper/errorMessages';
import { openErrorDialog } from '../../../../slices/errorDialogSlice/errorDialogSlice';
import { useApiClient } from '../../client';
import {
  FeatureFlagsClientQueryKeys,
  getGetFeatureFlagsQueryKey,
  useFeatureFlagsApiHelper,
} from './feature-flags-api-helpers';

// Queries

export function useGetFeatureFlagsQuery() {
  const client = useApiClient();
  const handleQueryError = useHandleQueryError();
  return useQuery({
    queryKey: getGetFeatureFlagsQueryKey(),
    placeholderData: (prev) => prev,
    queryFn: async () => {
      const { data, error } = await client.GET('/admin/feature-flags');
      handleQueryError({
        errorDialog: ERROR_DIALOG.MODAL,
        // @ts-expect-error mistatch between openapi-fetch error and backend error types
        error,
      });
      return data;
    },
  });
}

// Mutations

export function useUpdateFeatureFlagsMutation() {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { updateFeatureFlags } = useFeatureFlagsApiHelper();
  return useMutation({
    mutationKey: [FeatureFlagsClientQueryKeys.UPDATE_FEATURE_FLAGS],
    mutationFn: updateFeatureFlags,
    onError: (error) => {
      dispatch(openErrorDialog({ dialogErrorMsg: error.message, errorDialog: ERROR_DIALOG.MODAL }));
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: getGetFeatureFlagsQueryKey(),
      });
    },
  });
}
